module.exports = __webpack_public_path__ + "img/kontaktlos-alternative.720e2f51.png";